import './App.css'
import { BrowserRouter as Router, Routes, Route, useLocation, Navigate } from 'react-router-dom'
import NotificationProvider from './context/notificationContext'
import { AuthProvider, RequireAuth } from './context/authContext'
import { DeviceProvider } from './context/deviceContext'
import Login from './pages/auth/Login'
import LoadingProvider from "./context/loadingContext";
import InfoPage from './pages/dev/InfoPage'
import NotFound404 from './pages/errors/NotFound404'
import LayoutComponent from './component/frame/LayoutComponent'
import { routesConfig, routesConfigAdmin } from './routes'
import { createElement } from 'react'
import { LanguageProvider, useLanguage } from './context/languageContext';

const App = () => {


    return (
        <NotificationProvider>
            <DeviceProvider>
                <LoadingProvider>

                    <LanguageProvider>
                        <AuthProvider>
                            <Router>
                                <Routes>
                                    {/* Route per il login */}
                                    <Route path="/auth" element={<Login />} />
                                    <Route path="/dev-info" element={<InfoPage />} />
                                    {/* Route protette con RequireAuth */}
                                    <Route
                                        path="*"
                                        element={
                                            <RequireAuth>
                                                <DashboardLayout />
                                            </RequireAuth>
                                        }
                                    />
                                </Routes>
                            </Router>
                        </AuthProvider>
                    </LanguageProvider>
                </LoadingProvider>

            </DeviceProvider>
        </NotificationProvider>
    );
};

// Layout per la dashboard, include la navbar e il contenuto principale
const DashboardLayout = () => {
    const location = useLocation();
    const { t } = useLanguage();

    const route = routesConfig.filter((rout) => location.pathname.startsWith(rout.path))[0]
        ?? routesConfigAdmin.filter((rout) => location.pathname.startsWith(rout.path))[0];
    const pageName = route?.nameKey ? t(route.nameKey) : (route?.name ?? t('common.pageNotFound'));

    return (
        <>
            <LayoutComponent pageName={pageName}>
                <Routes>
                    <Route path='/' element={<Navigate to="/dashboard" replace />} />
                    {routesConfig.map(({ path, element }) => (
                        <Route key={path} path={path} element={createElement(element)} />
                    ))}
                    {routesConfigAdmin.map(({ path, element }) => (
                        <Route key={path} path={path} element={createElement(element)} />
                    ))}
                    <Route path="*" element={<NotFound404 />} />
                </Routes>
            </LayoutComponent>
        </>)
}
export default App
